import React, { useEffect } from "react";

export const TermsAndConditionsPDF = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
      <div className="termsPage">
        <h1>TERMS & CONDITIONS ACCEPTED BY USER</h1>
        <p className="mb-3">
          <b>Last Updated:</b> 20.03.2025{" "}
        </p>
        <p className="mb-3">
          Welcome to <a href="https://waqarzaka.net/">www.waqarzaka.net</a> (the
          "Website"). By accessing or using this Website, you agree to the
          following disclaimers, terms, and policies. If you do not agree with
          any part of this disclosure, please discontinue use immediately.{" "}
        </p>

        <h2>GENERAL DISCLAIMER</h2>
        <p className="mb-3">
          This Website is for educational and informational purposes only. We do
          not provide financial, investment, legal, or tax advice. Any content,
          materials, or courses available on this platform should not be
          construed as professional financial guidance. Always consult a
          licensed financial advisor, attorney, or tax professional before
          making any trading or investment decisions.
        </p>
        <h2>NO FINANCIAL OR INVESTMENT ADVICE</h2>
        <p className="mb-3">
          We are not financial advisors, brokers, or investment professionals.
          No content on this Website constitutes financial, investment, or legal
          advice. Any financial or trading decisions you make based on our
          content are strictly at your own risk. Past performance is not
          indicative of future results.
        </p>
        <h2>Risk Disclosure</h2>
        <p className="mb-3">
          Trading and investing involve substantial risk, including the
          potential loss of your entire investment. The cryptocurrency and forex
          markets are highly volatile and not suitable for all investors. Only
          invest funds that you can afford to lose.
        </p>
        <h2>Personal Responsibility</h2>
        <p className="mb-3">
          By using this Website, you acknowledge that you are solely responsible
          for your financial decisions. We do not guarantee any specific
          financial outcomes or success, and we are not liable for any losses or
          damages arising from the use of our materials. Testimonials or success
          stories are exceptional and not typical. <br />
        </p>
        <p className="mb-3">
          All content is provided “as is” and “as available,” with no warranties
          of accuracy, completeness, or reliability. Although we strive to keep
          information current, we make no guarantees that all content is free
          from errors or outdated material.
        </p>
        <h2>THIRD-PARTY LINKS AND AFFILIATES</h2>
        <p className="mb-3">
          This Website may include links to third-party websites, sponsored
          content, or affiliate promotions. We do not own or control third-party
          services and are not responsible for their accuracy, reliability, or
          legitimacy. Interactions with these services are at your own risk. We
          may receive commissions from affiliate links, but our content is not
          influenced by these affiliations.
        </p>
        <h2 style={{ marginTop: 80 }}>PRIVACY POLICY</h2>
        <p className="mb-3">
          By using this Website, you acknowledge that you have read and agreed
          to our Privacy Policy, which explains:
          <ul className="mt-3">
            <li>
              What personal data we collect (e.g., email, payment details,
              analytics)
            </li>
            <li>How we use and store that data</li>
            <li>Our third-party sharing practices</li>
            <li>Your rights, including how to request data deletion</li>
          </ul>
          Refer to the full [Privacy Policy] page for more information.
        </p>
        <h2>BILLING, PAYMENTS, & SUBSCRIPTIONS</h2>
        <h5>1. Support Ticket Requirement for Payment Issues</h5>

        <p>
          If you experience any issues accessing the platform{" "}
          <b>after a successful payment</b>, you must first create a support
          ticket via our Help Desk. Our support team will aim to resolve your
          issue <b>within 48 hours</b>.
        </p>
        <p>
          If your issue is not resolved after 48 hours, you may then proceed to
          open a <b>payment dispute or refund request</b> via Stripe.
        </p>
        <p className="mb-3">
          <b>⚠️ Important: </b> Initiating a dispute without first creating a
          support ticket is a violation of our terms and may result in denied
          claims.
        </p>
        <h5>2. Auto-Renewal Subscription Policy</h5>

        <p className="mb-3">
          By subscribing to our platform, you acknowledge and agree that your{" "}
          <b>subscription renews automatically every month</b>.
          <ul className="mt-3">
            <li>The first payment will require your authorization.</li>
            <li>
              Subsequent payments will be automatically deducted from your
              credit card without requiring re-authorization. <br /> You may
              cancel the subscription at any time before the next billing cycle
              through your account settings.
            </li>
          </ul>
        </p>
        <h2>REFUND POLICY</h2>
        <p className="mb-3">
          All sales of digital products, including courses and subscriptions,
          are <b>final and non-refundable</b>, except in cases of{" "}
          <b>accidental duplicate purchases</b>.
        </p>
        <h2>CONTENT USAGE & USER CONDUCT</h2>
        <ul>
          <li>
            Users may not copy, distribute, or reproduce any content without{" "}
            <b>written permission</b>.
          </li>
          <li>Unauthorized use of our content may result in legal action.</li>
          <li>
            Users must not engage in fraud, harassment, illegal activities, or
            violation of these terms.
          </li>
          <li>
            We reserve the right to <b>suspend or terminate any user account</b>{" "}
            that violates these terms.
          </li>
        </ul>
        <h2>LIMITATION OF LIABILITY</h2>
        <p className="mb-3">
          To the fullest extent permitted by law, we shall not be liable for any
          direct, indirect, incidental, consequential, or special damages
          arising from:
        </p>
        <ul>
          <li>Use of or inability to use our Website</li>
          <li>Errors or inaccuracies in content</li>
          <li>Third-party services or external links</li>
          <li>Loss of profits, revenue, or financial data</li>
        </ul>
        <h2 style={{ marginTop: 140 }}>MODIFICATIONS</h2>
        <p>
          We reserve the right to update or modify this legal disclaimer and
          terms of use at any time without prior notice. It is your
          responsibility to check this page regularly for updates.
        </p>
      </div>
    </div>
  );
};
